module.exports = __webpack_public_path__ + "static/img/1.47ce994.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/1.png
// module id = 7hDT
// module chunks = 0